/** Od ovog broja (uključivo) prikazuje se "Sve slobodno" umjesto točnog broja. */
export const ALL_AVAILABLE_SPOTS_THRESHOLD = 15;

export function formatAvailableSpotsLabel(
    availableSpots: number,
    t: (key: string) => string,
): string {
    if (availableSpots >= ALL_AVAILABLE_SPOTS_THRESHOLD) {
        return t('tourDetails.common.terms.allAvailable');
    }
    return String(availableSpots);
}
